import { PRODUCT_TYPE, STEPS } from 'domain/enums'
import {
  FEED_ITEM_TITLE,
  FEED_ITEM_REJECTION_DESCRIPTION,
} from 'lead/domain/constants'

const transformObjectEqualKeyAndValue = thing =>
  Object.keys(thing).reduce(
    (prev, current) => ({ ...prev, [current]: current }),
    {},
  )

const feedTitleKeys = transformObjectEqualKeyAndValue(FEED_ITEM_TITLE)

const feedDescriptionKeys = transformObjectEqualKeyAndValue(
  FEED_ITEM_REJECTION_DESCRIPTION,
)

const productTypeKeys = transformObjectEqualKeyAndValue(PRODUCT_TYPE)

const proposalStepKeys = transformObjectEqualKeyAndValue(STEPS)

export {
  feedTitleKeys,
  feedDescriptionKeys,
  productTypeKeys,
  proposalStepKeys,
  transformObjectEqualKeyAndValue,
}
